import React from "react";
import Title from "../components/Title";
import { useScroll } from "../components/useScroll";
import { motion } from "framer-motion";
import "../styles/sections/Why.scss";
import {
  topContainerAnimation,
  reasonsAnimation,
} from "../utils/Animations";

function Why() {
  const [element, controls] = useScroll();

  return (
    <div className="why-container" id="services" ref={element}>
      <div className="container">
        <motion.div
          className="top"
          variants={topContainerAnimation}
          animate={controls}
          transition={{
            duration: 1,
          }}
        >
          <Title title="Why RIVERPOINT ?" color="pink" lineCenter={true} />
          <div className="subTitle">
            <p>
              Always stay updated with the technologies thus we help our clients
              by giving the best solutions for thier needs.
            </p>
          </div>
        </motion.div>
        <div className="content">
          <motion.div
            className="reasons"
            variants={reasonsAnimation}
            animate={controls}
            transition={{ type: "tween", duration: 0.5 }}
          >
            <ul>
              <li>Over 4+ years of industry wide expierence</li>
              <li>
                Provide solutions to our multiple global clients or website
                traffic generation and workflow
              </li>
              <li>A focused team of 4+ people</li>
              <li>99% adhere to service level contract</li>
              <li>Ready to recieve service request 24/7</li>
            </ul>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default Why;
